import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { AuthModule } from '@app/auth/auth.module';
import { BookingPartModule } from '@app/booking-part/booking-part.module';
import { CustomerAccountModule } from '@app/customer-account/customer-account.module';
import { HomepageModule } from '@app/homepage/homepage.module';
import { LanguageCustomLoader } from '@app/language-custom-loader';
import { SalonDetailsModule } from '@app/salon-details/salon-details.module';
import { SalonsSearchResultsModule } from '@app/salons-search-results/salons-search-results.module';
import { SupportedLanguagesCodes } from '@app/shared/enums/supported-language-codes.enum';
import { JwtInterceptor } from '@app/shared/interceptors/jwt-interceptor';
import { SpinnerInterceptor } from '@app/shared/interceptors/spinner.interceptor';
import { SharedModule } from '@app/shared/shared.module';
import { VisitReviewModule } from '@app/visit-reviews/visit-review.module';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GiftsModule } from '@app/gifts/gifts.module';
import { MailingModule } from '@app/mailing/mailing.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: () => new LanguageCustomLoader()
      }
    }),
    ModalModule.forRoot(),
    HomepageModule,
    AppRoutingModule,
    SharedModule,
    SalonsSearchResultsModule,
    SalonDetailsModule,
    VisitReviewModule,
    BookingPartModule,
    CustomerAccountModule,
    AuthModule,
    GiftsModule,
    MailingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private translate: TranslateService) {
    this.translate.addLangs(Object.values(SupportedLanguagesCodes));
    this.translate.setDefaultLang(SupportedLanguagesCodes.Dutch);
    this.translate.use(SupportedLanguagesCodes.Dutch);
  }
}
